import { connect } from 'react-redux';
import LogoutModal from './LogoutModal';
import { hideLogoutModal } from '../screen/screenActions';
import selectors from '../../rootSelectors';
import { logUserOut } from '../user/userActions';
import { clearCDNCachedContent } from '../utils/offlineUtils';

export const mapStateToProps = state => ({
    isLogoutModalVisible: selectors.getIsLogoutModalVisible(state),
});

export const mapDispatchToProps = dispatch => ({
    hideModal: () => {
        dispatch(hideLogoutModal());
    },
    logUserOut: () => {
        clearCDNCachedContent().then(logUserOut);
    },
});

const LogoutContainer = connect(mapStateToProps, mapDispatchToProps)(LogoutModal);

export default LogoutContainer;
